<template>
  <el-dialog :visible="show" :custom-class="'spr-dialog ' + name" :size="size" @update:visible="(flag) => this.$emit('update:show', flag)" @open="() => this.$emit('open')">
    <span class="title" slot="title">{{title}}</span>
    <slot></slot>
    <span slot="footer">
      <el-button type="primary" @click="() => this.$emit('confirm')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    name: String,
    title: String,
    show: Boolean,
    size: String,
  },
}
</script>

<style lang="less">
.spr-dialog {
  &.company,
  &.branchCompany,
  &.permissions {
    width: 1150px;
  }
  &.contacts {
    width: 551px;
    padding-right: 10px;
  }
  &.point {
    width: 973px;
  }
  &.engineer {
    width: 930px;
  }
  .el-dialog__header {
    padding: 30px 30px 0;
  }
  .el-dialog__body {
    padding-top: 24px;
    padding-bottom: 10px;
  }
  .title {
    font-size: 24px;
    color: #354052;
  }
  .el-form {
    & .el-form-item:last-child {
      margin-bottom: 0;
    }
    .el-form-item {
      margin-bottom: 20px;
    }
    .el-form-item.bold > .el-form-item__label {
      color: #475669;
      font-size: 18px;
      font-weight: bold;
    }
    &.sub-form.el-form--label-right .el-form-item__label{
      text-align: right;
    }
    .el-checkbox-group {
      .el-checkbox {
        margin-left: 30px;
      }
      .el-checkbox:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Dialog.vue?e0e76f5a